import {createAsyncThunk} from '@reduxjs/toolkit';
import {AuthClientSingleton} from '../utils/auth';
import {ErrorTags, EventNames} from 'src/lib/analytics/events';
import Tracker from 'src/lib/analytics/tracker';
import Cookies from 'js-cookie';
import {getUserProfile} from './userProfile';

export const getLocalAccessToken = createAsyncThunk('users/getLocalAccessToken', async (_, thunkApi) => {
    const data = AuthClientSingleton.getToken();
    if (data) {
        thunkApi.dispatch(getUserProfile({}));
        Tracker.trackEvent(EventNames.LOCAL_ACCESS_TOKEN_SUCCESS);
        return data;
    } else {
        const err = new Error('No local access token found');
        Tracker.trackError(err, ErrorTags.GET_LOCAL_ACCESS_TOKEN_ERROR);
        throw err;
    }
});

export const logout = createAsyncThunk('users/logout', async () => {
    try {
        localStorage.removeItem('percept_user_id');
        localStorage.removeItem('percept_unique_id');
        localStorage.removeItem('PERCEPT_GLOBAL_email');
        const data = await AuthClientSingleton.logout();
        Tracker.logout();
        Cookies.remove('name');
        Cookies.remove('email');
        Cookies.remove('user_id');
        return data;
    } catch (e: any) {
        Tracker.trackError(e, ErrorTags.LOGOUT_ERROR);
        throw e;
    }
});
